const PMReport = () => import('@/pages/ProjectManagement/PMReport.vue');
import oidc from '@/vue-oidc-client';
import PermissionsEnum from '@/ship/Enums/PermissionsEnum';
const permissions: PermissionsEnum[] = [];
export default [
    {
        name: 'projectManagement.document.bpc',
        path: 'report/document/bpc',
        component: PMReport,
        meta: { authName: oidc.authName, showSidebar: true, permissions },
    },
    {
        name: 'projectManagement.document.dpcExec',
        path: 'report/document/dpc-exec',
        component: PMReport,
        meta: { authName: oidc.authName, showSidebar: true, permissions },
    },
    {
        name: 'projectManagement.document.dpcQuart',
        path: 'report/document/dpc-quart',
        component: PMReport,
        meta: { authName: oidc.authName, showSidebar: true, permissions },
    },
    {
        name: 'projectManagement.document.weeklyReport',
        path: 'report/document/weekly',
        component: PMReport,
        meta: { authName: oidc.authName, showSidebar: true, permissions },
    },
];
